import { useTourRegionSelectedTag } from './useTourRegionSelectedTag';
import { useTourRegionTagsAdapters } from './useTourRegionTagsAdapters';
import { useTourRegionTagsFiltering } from './useTourRegionTagsFiltering';
import { useTourRegionVisibleTags } from './useTourRegionVisibleTags';
import type { Ref } from 'vue';
import type { RegionTag, RegionTagUrls } from '@/shared/api/experience';

export function useTourRegionRubrics(regionTags: Ref<RegionTag[] | undefined>, isMobile: Ref<boolean>) {
  const context = computed(() => 'tours' as keyof RegionTagUrls);

  const { selectedValue, cachedSelectedValue } = useTourRegionSelectedTag(regionTags, context);
  const { popupTags, rubricsTags } = useTourRegionTagsFiltering(regionTags, context);
  const { popupTagsMapped, rubricsAdapters } = useTourRegionTagsAdapters(rubricsTags, popupTags, context);
  const { visibleTags } = useTourRegionVisibleTags(rubricsAdapters, selectedValue, isMobile);

  return {
    selectedValue,
    cachedSelectedValue,
    popupTagsMapped,
    rubricsAdapters,
    visibleTags,
  };
}
